import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change (react-router does not do this by default).
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};
